let csrfToken = '';

export function setCsrf(value: string | undefined): void {
  csrfToken = value ?? '';
}

export class ApiClientError extends Error {
  constructor(
    message: string,
    public status: number,
    public code: string,
    public details?: unknown
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData))
    headers.set('content-type', 'application/json');
  if (csrfToken && !['GET', 'HEAD'].includes(init.method ?? 'GET'))
    headers.set('x-csrf-token', csrfToken);
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' });
  const type = response.headers.get('content-type') ?? '';
  const body = type.includes('application/json')
    ? ((await response.json()) as {
        error?: { message?: string; code?: string; details?: unknown };
      })
    : null;
  if (!response.ok) {
    const error = body?.error;
    throw new ApiClientError(
      error?.message ?? 'Permintaan gagal.',
      response.status,
      error?.code ?? 'REQUEST_ERROR',
      error?.details
    );
  }
  return body as T;
}

export const get = <T>(path: string) => api<T>(path, { cache: 'no-store' });
export const post = <T>(path: string, data?: unknown) =>
  api<T>(path, {
    method: 'POST',
    body: data instanceof FormData ? data : data === undefined ? undefined : JSON.stringify(data)
  });
export const put = <T>(path: string, data: unknown) =>
  api<T>(path, { method: 'PUT', body: JSON.stringify(data) });
export const patch = <T>(path: string, data: unknown) =>
  api<T>(path, { method: 'PATCH', body: JSON.stringify(data) });
export const remove = <T>(path: string) => api<T>(path, { method: 'DELETE' });
